import React from 'react';
import { Modal } from 'react-bootstrap';
import { useMutation } from '@apollo/react-hooks';
import { Button } from 'modules';
import { CreateContractClient2Mutation } from 'queries/Contract';

interface SubmitModalProps {
  contract: GQL.IContract;
  onSubmit: () => void;
  onClose: () => void;
}

const SubmitModal = ({ contract, onSubmit, onClose }: SubmitModalProps) => {
  const [createContractClient2] = useMutation(CreateContractClient2Mutation);

  const handleSubmit = () => {
    createContractClient2({
      variables: {
        id: contract.id,
        data: {},
      },
    }).then(onSubmit);
  };

  // kontrola, zda smlouva již nemá 2. klienta
  if (!!contract.client2) {
    onSubmit();
  }

  return (
    <Modal show onHide={onClose} backdrop="static" keyboard={false} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Manžel / Manželka</Modal.Title>
      </Modal.Header>
      <Modal.Body>Naozaj chcete pridať k zmluve manžela/manželku?</Modal.Body>
      <Modal.Footer className="text-right">
        <Button variant="secondary" onClick={onClose}>
          Nie
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Áno
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubmitModal;
